import BaseFormView from "./baseFormView";
import ChangePasswordAuthenticationModel from "scripts/models/changePasswordAuthenticationModel";
import templateChangePasswordForm from "templates/changePasswordForm.hbs";

class ChangePasswordFormView extends BaseFormView {
  constructor(options) {
    super(options);

    this.oldPassword = options && options.oldPassword;

    this.bindModel(
      new ChangePasswordAuthenticationModel(
        {},
        {
          username: options && options.username,
          token: options && options.token,
        },
      ),
    );
  }

  get template() {
    return templateChangePasswordForm;
  }

  get events() {
    return {
      "blur form *[name]": "onBlurValidate",
      "submit form": "onSubmit",
    };
  }

  render() {
    this.$el.html(this.template());

    if (this.oldPassword) {
      const $passwordField = $("#bb-change-password-form-old-password-field");

      $passwordField.attr("type", "hidden");
      $passwordField.val(this.oldPassword);
    }

    this.loaderView
      .appendTo(this.$el.find(".bb-form-submit-button-loader-region"))
      .render();

    return this;
  }

  onSubmitFailed(error) {
    this.enableSubmit(true);
    this.trigger("failure", error);
  }

  save() {
    this.clearErrors();
    return this.model.save(this.toJSON());
  }
}

export default ChangePasswordFormView;
